module.exports = __webpack_public_path__ + "img/seo-reporter.83e141ae.webp";